export default "__VITE_ASSET__k1oNFxn7__"